<template>
  <ImportExport :title="$t('keywords.db_register')" type="cruddatabase" :headers="headers" v-on="$listeners">
    <template #item.tenant="{ item }">
      <v-text-field v-model="item.tenant" style="margin-bottom: -2.3vh" outlined dense :rules="alphaNumericRules(item.tenant)" />
    </template>

    <template #item.active="{ item }">
      <v-switch v-model="item.active" />
    </template>

    <template #item.credentialName="{ item }">
      <CredentialSelect :rules="requiredRules(item.credentialName)" v-model="item.credentialName" type="DATABASE" required />
    </template>
  </ImportExport>
</template>

<script>
import ImportExport from '../core/ImportExport.vue'
import { alphaNumericRules, requiredRules } from '../../utils/rules'
import CredentialSelect from '../core/CredentialSelect.vue'

export default {

  components: { ImportExport, CredentialSelect },

  data: () => ({
    alphaNumericRules,
    requiredRules
  }),

  computed: {
    headers () {
      return [
        {
          text: this.$t('keywords.method_name'),
          value: 'tenant'
        },
        {
          text: this.$t('check.active'),
          value: 'active'
        },
        {
          text: this.$t('db_register.credential'),
          value: 'credentialName'
        }
      ]
    }
  }

}
</script>
